import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const UserNameChanged = createAction(
  '[Search: Edit User]: User Name Changed',
  props<{ userName: string }>(),
);

export const ChangePasswordVisibility = createAction(
  '[Search: Edit User]: Change Password Visibility',
);

export const UserPasswdChanged = createAction(
  '[Search: Edit User]: User Password Changed',
  props<{ userPassword: string }>(),
);

export const UserDeactivatedChanged = createAction('[Search: Edit User]: User Deactivated Changed');

export const UserQuicksightChanged = createAction('[Search: Edit User]: User Quicksight Changed');

export const IntegrationUserChanged = createAction('[Search: Edit User]: Integration User Changed');

export const UserDisplayedNameChanged = createAction(
  '[Search: Edit User]: User Displayed Name Changed',
  props<{ displayedName: string }>(),
);

export const UserEmailChanged = createAction(
  '[Search: Edit User]: User Email Changed',
  props<{ email: string }>(),
);

export const UserSecGroupChanged = createAction(
  '[Search: Edit User]: User Security Group Changed',
  props<{ securityGroup: string }>(),
);

export const UserBusinessGroupChanged = createAction(
  '[Search: Edit User]: User Business Group Changed',
  props<{ businessGroup: string }>(),
);

export const UserLanguageChanged = createAction(
  '[Search: Edit User]: User Language Changed',
  props<{ language: string }>(),
);

export const UserCountryChanged = createAction(
  '[Search: Edit User]: User Country Changed',
  props<{ country: string[] }>(),
);

export const Update = createAction(
  '[Search: Edit User]: Update',
  props<{ status: 'activated' | 'deactivated' | 'updated' }>(),
);

export const UpdateUser = createAction(
  '[Search: Edit User]: Update User',
  props<{ status: 'activated' | 'deactivated' | 'updated' }>(),
);

export const UpdateUserSuccess = createAction(
  '[Search: Edit User]: Update User Success',
  props<{ status: 'activated' | 'deactivated' | 'updated' }>(),
);

export const UpdateUserFailed = createAction(
  '[Search: Edit User]: Update User Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const Create = createAction('[Search: Edit User]: Create');

export const CreateUser = createAction('[Search: Edit User]: Create User');

export const CreateUserSuccess = createAction(
  '[Search: Edit User]: Create User Success',
  props<{ res: any }>(),
);

export const CreateUserFailed = createAction(
  '[Search: Edit User]: Create User Failed',
  props<{ error: HttpErrorResponse }>(),
);
